import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    appToken: "",
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAppToken: (state, action) => {
            state.appToken = action.payload
        },       
    },
})

// Action creators are generated for each case reducer function
export const { setAppToken } = authSlice.actions

export default authSlice.reducer